import { MutateCoachForm } from '@/features/coach/schema/mutate-coach-schema';
import { CoachDoc } from '@/features/home/services/get-coach';
import { getCurrentEnvUrls } from '@/libs/config';
import { WithId } from '@/libs/firebase/firestore';
import parsePhoneNumberFromString from 'libphonenumber-js';

export const convertCoachDocToMutateCoachForm = (coach: WithId<CoachDoc>): MutateCoachForm => {
  const baseUrl = getCurrentEnvUrls().pictureUrl?.trim() || undefined;
  const inferredAvatarUri = baseUrl
    ? `${baseUrl}${coach.id}.jpg?alt=media&updated_at=${coach.updated_at}`
    : undefined;

  const phoneNumberParse = parsePhoneNumberFromString(`${coach.phone}`);
  const hasCountryCode = coach.phone?.startsWith('+');
  const phoneNumber = hasCountryCode
    ? (phoneNumberParse?.formatInternational() ?? '')
    : (
        parsePhoneNumberFromString(`+1${coach.phone ?? ''}`)?.formatInternational() ?? ''
      ).toString();

  return {
    phoneNumber: phoneNumber,
    countryCode: phoneNumberParse?.country ?? 'US',
    streetAddress: coach?.address?.street1 ?? '',
    streetAddress2: coach?.address?.street2 ?? '',
    city: coach?.address?.city ?? '',
    state: coach?.address?.state ?? '',
    zipCode: coach?.address?.zipcode ?? '',
    avatar: inferredAvatarUri
      ? {
          uri: inferredAvatarUri,
        }
      : undefined,
  };
};

export const convertMutateCoachFormToCoachUpdate = (form: MutateCoachForm): Partial<CoachDoc> => {
  return {
    phone: form.phoneNumber,
    address: {
      street1: form.streetAddress,
      street2: form.streetAddress2,
      city: form.city,
      state: form.state,
      zipcode: form.zipCode,
    },
    updated_at: new Date().toISOString(),
  };
};
